import 'gleam-shared/embeds/CaptureButton.scss'

import triggerCapture from 'gleam-shared/domain/triggerCapture'
import { prefetchScript } from 'gleam-shared/browser/prefetch'
import { writeDom, cancelFastDom } from 'gleam-shared/browser/fastDom'

import DeadPreview from 'gleam-shared/embeds/DeadPreview'
import BasePreview from 'gleam-shared/embeds/BasePreview'

const MARKER = 'CaptureButton'
const DISABLED_ATTR = 'disabled'
const CAPTURE_BUTTON_CLASS = 'capture-button'

export default function CaptureButton(button, key, script) {
  try {
    if (!key || !script) {
      throw new Error('The expected arguments are missing!')
    }

    return RealPreview(button, key, script)
  } catch (err) {
    return DeadPreview('The capture button', err)
  }
}

function RealPreview(button, key, script) {
  const preview = BasePreview({
    destroy,
    description: `The ${key} capture`
  })

  prefetchScript(script, MARKER)
  button.addEventListener('click', onClick, { passive: true })

  return preview

  function destroy() {
    button.removeEventListener('click', onClick)
  }

  function onClick() {
    writeDom(setDisabled)
    return triggerCapture(key, script, MARKER).catch((err) => {
      preview.errorEmitter.emit(err)
    }).finally(() => {
      writeDom(unsetDisabled)
    })
  }

  function setDisabled() {
    cancelFastDom(unsetDisabled)
    button.classList.add(CAPTURE_BUTTON_CLASS)
    button.setAttribute(DISABLED_ATTR, true)
  }

  function unsetDisabled() {
    cancelFastDom(setDisabled)
    button.classList.add(CAPTURE_BUTTON_CLASS)
    button.removeAttribute(DISABLED_ATTR)
  }
}
